
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workingolf/university-program",
      function () {
        return require("private-next-pages/workingolf/university-program.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workingolf/university-program"])
      });
    }
  